import { composeCategoryHeaderLinks } from "../../../../components/CategoryHeader/helpers";
const extractCategoryData = category => ({
  breadcrumbs: category.breadcrumbs || [],
  categoryId: category.details?.id,
  childLinks: category.childLinks || [],
  siblingLinks: category.siblingCategories || [],
  relatedLinks: category.relatedCategories || []
});
export const getCategoryHeaderLinks = state => {
  if (!state?.category) {
    return [];
  }
  const categoryData = extractCategoryData(state.category);

  if (
    categoryData.childLinks.length === 0 &&
    categoryData.relatedLinks.length === 0 &&
    categoryData.siblingLinks.length === 1
  ) {
    return [];
  }

  return composeCategoryHeaderLinks({
    childLinks: categoryData.childLinks,
    siblingLinks: categoryData.siblingLinks,
    relatedLinks: categoryData.relatedLinks,
    breadcrumb: categoryData.breadcrumbs,
    categoryId: categoryData.categoryId
  });
};
